import useAsync from "lib/@hooks/useAsync"
import { getMakeScheduleId } from "routes/schedule/my-schedules/my-custom-schedules/controller/make-schedule-id"
import { useState } from "react"
import { useRefresh } from "lib/@hooks/useRefresh"
import { Bound } from "lib/@components/binding/Bound"
import { DialogContent, DialogTitle, Typography } from "@mui/material"
import { PropertyBox } from "lib/@components/property-box"
import { CodeEditor } from "routes/schedule/components/code-editor"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { OkCancel } from "lib/@components/okCancel"

export function NewScheduleDialog({ originatingScheduleId, originatingScheduleCode } = {}) {
    const { scheduleId, clientCode } = useAsync(getMakeScheduleId, {})
    const [schedule] = useState({ originatingScheduleId, originatingScheduleCode, ScheduleType: 2 })
    const refresh = useRefresh()
    schedule.clientScheduleId = scheduleId

    return (
        !!clientCode && (
            <Bound target={schedule} refresh={refresh}>
                <DialogTitle data-cy="new-schedule-dialog-title">Create a new schedule</DialogTitle>
                <DialogContent>
                    <PropertyBox pt={1} spacing={0}>
                        <Typography sx={{ mb: 1 }} component="div" variant="caption">
                            Schedule Code
                        </Typography>
                        <CodeEditor schedule={schedule} clientCode={clientCode.padLeft(4, "0")} />
                        <BoundTextField
                            data-cy="schedule-name"
                            sx={{ mt: 2 }}
                            autoFocus
                            sideEffects
                            field="title"
                            id="new-schedule-dialog"
                        />
                    </PropertyBox>
                </DialogContent>
                <OkCancel value={schedule.title ? schedule : undefined} />
            </Bound>
        )
    )
}
